module.exports = __webpack_public_path__ + "assets/img/IMG038.27ff696e.png";